import loadable from '@loadable/component';

export const InvalidLinkPageLoadable = loadable(
  () => import('./InvalidLinkPage'),
  {
    resolveComponent: (module) => module.InvalidLinkPage,
  },
);
